import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { FilterField } from '../filtered-search/filtered-search.component';

export interface CustomDateDialogData {
  filterField: FilterField;
}

export interface DateRangeForm {
  start: FormControl<Date | null>;
  end: FormControl<Date | null>;
}

@Component({
  selector: 'app-custom-date-dialog',
  templateUrl: './custom-date-dialog.component.html',
  styleUrls: ['./custom-date-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomDateDialogComponent {
  today = new Date();
  customDateForm: FormGroup<DateRangeForm>;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<CustomDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomDateDialogData,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
  ) {
    this.customDateForm = this.fb.group({
      start: [null as Date | null, Validators.required],
      end: [null as Date | null, Validators.required],
    });
  }

  onApply(): void {
    if (this.customDateForm.valid) {
      this.dialogRef.close({
        field: this.data.filterField.field,
        value: this.customDateForm.value,
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
